import React from 'react'
import SupplierDelete from "./SupplierDelete";
import SupplierEdit from "./SupplierEdit";

const SupplierActions = ({record, updater}) => {

    return(
        <React.Fragment>
            <SupplierEdit supplier={record} updater={updater} />
            <SupplierDelete supplier={record} updater={updater} />
        </React.Fragment>
    )
}
export default SupplierActions